export var OrganisationFeatureFlags;
(function (OrganisationFeatureFlags) {
    /** Access to the upcoming beta version of UI */
    OrganisationFeatureFlags["UI_BETA"] = "UI_BETA";
})(OrganisationFeatureFlags || (OrganisationFeatureFlags = {}));
//# sourceMappingURL=organisation.js.map